(function() {
  const STORAGE_KEY = 'ad_tracking_data';
  const EXPIRY_DAYS = 90;
  const TRACKED_PARAMS = ['gclid', 'gad_source', 'gad_campaignid', 'gbraid'];

  // Probe whether the browser would block GTM requests
  var gtmBlocked = null;
  fetch('https://www.googletagmanager.com/gtm.js', { mode: 'no-cors' })
    .then(function() { gtmBlocked = false; })
    .catch(function() { gtmBlocked = true; });

  // Store tracking params in localStorage with expiry
  const params = new URLSearchParams(window.location.search);
  const captured = {};
  TRACKED_PARAMS.forEach(function(key) {
    const val = params.get(key);
    if (val) captured[key] = val;
  });

  if (Object.keys(captured).length > 0) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      values: captured,
      expiry: Date.now() + (EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    }));
  }

  function getStoredParams() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (Date.now() > data.expiry) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data.values;
  }

  window.addEventListener('CookieScriptAcceptAll', function() {
    sessionStorage.setItem('cs_consent', 'accepted');
  });

  window.addEventListener('CookieScriptAccept', function(e) {
    if (e.detail && e.detail.categories && e.detail.categories.includes('targeting')) {
      sessionStorage.setItem('cs_consent', 'accepted');
    } else {
      sessionStorage.setItem('cs_consent', 'rejected');
    }
  });

  window.addEventListener('CookieScriptReject', function() {
    sessionStorage.setItem('cs_consent', 'rejected');
  });

  function gtmUnlikelyToFire() {
    var consent = sessionStorage.getItem('cs_consent');
    return consent !== 'accepted' || gtmBlocked === true;
  }

  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    const result = originalFetch.apply(this, arguments);

    if (typeof url === 'string' && url.includes('/cart/add')) {
      result.then(function() {
        const stored = getStoredParams();

        if (stored && Object.keys(stored).length > 0 && gtmUnlikelyToFire()) {
          const attributes = Object.assign({}, stored, {
            ad_tracking_reason: gtmBlocked ? 'gtm_blocked' : 'no_consent'
          });

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attributes })
          });
        }
      });
    }

    return result;
  };
})();